import { DoOptimizePage } from "./DoOptimizePage";

export function DoOptimizeHelper(rootNode, pageLayoutMgr, curDoc) {
  //function DoOptimizeHelper(rootNode, pageLayoutMgr, curDoc, wsMgr)
  var docPrefs = curDoc.GetDocPrefs();
  var pageOpt = docPrefs.GetPageOpt(true);
  if (pageOpt == null) {
    return;
  }

  var aspectRatio = pageOpt.GetAspectRatio();
  // var aspectY = pageOpt.GetAspectY();
  // var aspectRatio = aspectX/aspectY;

  var allowSort = pageOpt.GetAllowSort();
  var treeSingles = pageOpt.GetTreeSingles();
  var branchPref = pageOpt.GetBranchPref();

  DoOptimizePage(
    rootNode,
    pageLayoutMgr,
    aspectRatio,
    allowSort,
    treeSingles,
    branchPref,
    "",
    null,
    curDoc
  );
}
